@if (isVisible) {
  <div class="absolute inset-0 bg-gray-500/20 backdrop-blur-sm pointer-events-auto cursor-pointer"
       (click)="close()"></div>
  <div class="absolute left-1/2 -translate-x-1/2 top-1/3 -translate-y-1/2 pointer-events-auto">
    <ng-content/>
  </div>
}
